import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=67db9ade"
import script from "./ThirdStep.vue?vue&type=script&lang=js"
export * from "./ThirdStep.vue?vue&type=script&lang=js"
import style0 from "./ThirdStep.vue?vue&type=style&index=0&id=67db9ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports